import { createAction } from 'redux-actions';

import { UPDATE_FILTERS, RESET_FILTERS } from './types';

export const updateFilters = createAction(UPDATE_FILTERS);
export const resetFilters = createAction(RESET_FILTERS);
